module.exports = __webpack_public_path__ + "img/MS-M-6.4ef665c9.svg";